import { useContext } from 'react';
import { TenantContext, type TenantState } from '@/context/tenantTypes';
import type { Tenant } from '@/types';

export function useTenant(): TenantState {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
}

/**
 * Hook that requires a valid tenant - throws if tenant is not loaded
 */
export function useRequiredTenant(): Tenant {
  const { tenant, isLoading, error } = useTenant();
  if (isLoading) {
    throw new Error('Tenant is still loading');
  }
  if (error) {
    throw new Error(`Tenant error: ${error.message}`);
  }
  if (!tenant) {
    throw new Error('No tenant available');
  }
  return tenant;
}
